<template>
    <div>
        <appPage :back-img="info?.background" class="p-0! flex flex-col" :isDefaultBackground="true"
            @click="showPreviewName = false; showLevelTip = false">
            <div class="header flex items-center justify-between p-20px  top-0 left-0 w-100vw fixed">
                <div class="flex items-center">
                    <div class="header-left w-28px h-28px cursor-pointer" @click="handleBack">
                        <img src="@/assets/images/mine/left.webp" alt="" class="w-full h-full" />
                    </div>
                </div>
                <van-popover v-model:show="showPopover" placement="bottom-end" actions-direction="vertical">
                    <van-grid clickable :border="false" column-num="1" style="width: 180px;">
                        <div v-for="i in popoverList" :key="i.name" class="w-100% flex items-center p-10px"
                            @click="handlePopover(i.name)">
                            <img :src="i.icon" alt="" class="w-20px" />
                            <div class="ml-5px color-#01031B font-500 text-12px opacity-50 mt-2px">{{ i.name }}</div>
                        </div>
                    </van-grid>
                    <template #reference>
                        <div class="header-right w-28px h-28px">
                            <img src="@/assets/images/message/more.webp" alt="" class="w-full h-full" />
                        </div>
                    </template>
                </van-popover>
            </div>
            <div class="h-250px" @click.stop="handlePreviewBackgroundAlbum(info?.background)"></div>
            <div class="w-full bg-#01031B flex-1 p-20px pt-3px relative flex flex-col pb-50px">
                <div class="w-85px h-85px rounded-full overflow-hidden absolute top--30px left-20px bg-#01031B cursor-pointer"
                    @click="handlePreviewAvatar">
                    <!-- <img :src="info.avatar" alt="" fit="cover" class="w-90% rounded-full ml-5% mt-4px" /> -->
                    <div class="rounded-full overflow-hidden mt-5px ml-5px w-75px h-75px">
                        <van-image :src="info?.avatar" width="100%" height="100%" fit="cover">
                            <template v-slot:loading>
                                <div class="w-100% h-100%">
                                    <img src="@/assets/images/message/defaultAvatar.webp" alt="" class="w-full h-full"
                                        @load="handleLoad" />
                                </div>
                            </template>
                        </van-image>
                    </div>
                </div>
                <div class="flex items-center justify-between">
                    <div class="color-#fff ml-100px relative">
                        <div @click.stop="handlePreviewName"
                            class="text-20px  color-#fff font-900 max-w-160px text-ellipsis overflow-hidden">
                            {{ info?.name }}
                        </div>
                        <div v-if="showPreviewName"
                            class="absolute top--50px right-0px text-10px bg-#fff w-200px p-10px color-#333 text-14px font-500 warp rounded-10px">
                            {{ info?.name }}
                        </div>
                        <div class="text-10px flex">
                            ID:{{ info?.id }}
                            <img v-if="!isShowFree" src="@/assets/images/message/crystal.svg" class="ml-5px" />
                            <span class="ml-2px">
                            </span>
                            <!-- <img src="@/assets/images/home/crystal.webp" alt="" class="w-10px h-10px " /> -->
                            <span class="color-#A0C3FF" v-if="!isShowFree">
                                {{ expenses }}{{ t('messageDetail.perMessage') }}
                            </span>
                            <span class="color-#A0C3FF" v-else>
                                {{ t('messageDetail.free') }}
                            </span>

                        </div>
                    </div>
                    <div class="w-30px h-30px ml-34px cursor-pointer mt-4px" @click="handleLike"
                        :class="{ 'heartbeat': isLiking }">
                        <img src="@/assets/images/message/like.webp" alt="" class="w-full h-full"
                            v-if="info?.isFavorite" />

                        <img src="@/assets/images/message/like_no.webp" alt="" class="w-full h-full" v-else>
                    </div>
                </div>
                <div class="mt-15px relative pb-15px">
                    <div class="flex items-center justify-around" @click.stop="handleToggleLevelTip">
                        <div class="text-12px font-900 color-#fff">
                            <img src="@/assets/images/message/lv1_on.webp" alt="" class="w-12px h-12px"
                                v-if="progressPercent?.type >= 1" />
                            <img src="@/assets/images/message/lv1.webp" alt="" class="w-12px h-12px" v-else />
                        </div>
                        <div class="text-12px font-900 color-#fff">
                            <img v-if="progressPercent?.type >= 2" src="@/assets/images/message/lv2_on.webp" alt=""
                                class="w-12px h-12px" />
                            <img v-else src="@/assets/images/message/lv2.webp" alt="" class="w-12px h-12px" />
                        </div>
                        <div class="text-12px font-900 color-#fff">
                            <img v-if="progressPercent?.type >= 3" src="@/assets/images/message/lv3_on.webp" alt=""
                                class="w-12px h-12px" />
                            <img v-else src="@/assets/images/message/lv3.webp" alt="" class="w-12px h-12px" />
                        </div>
                        <div class="text-12px font-900 color-#fff">
                            <img v-if="progressPercent?.type >= 4" src="@/assets/images/message/lv4_on.webp" alt=""
                                class="w-12px h-12px" />

                            <img v-else src="@/assets/images/message/lv4.webp" alt="" class="w-12px h-12px" />
                        </div>
                        <div class="text-12px font-900 color-#fff">
                            <img v-if="progressPercent?.type >= 5" src="@/assets/images/message/lv5_on.webp" alt=""
                                class="w-12px h-12px" />

                            <img v-else src="@/assets/images/message/lv5.webp" alt="" class="w-12px h-12px" />
                        </div>
                    </div>
                    <div class="progress-bar" @click.stop="handleToggleLevelTip">
                        <div class="progress-fill" :style="{ width: `${progressPercent?.progress || 0}%` }"></div>
                        <div class="flex items-center justify-around absolute w-100% top-0 progress-fill-item">
                            <div class="w-2px h-4px bg-red item"></div>
                            <div class="w-2px h-4px bg-red item"></div>
                            <div class="w-2px h-4px bg-red item"></div>
                            <div class="w-2px h-4px bg-red item"></div>
                            <div class="w-2px h-4px bg-red item"></div>
                        </div>
                    </div>

                    <div class="flex items-center justify-around" @click.stop="handleToggleLevelTip">
                        <div class="text-10px font-500 color-#fff">
                            {{ t('messageDetail.levelFormat', { level: 1 }) }}
                        </div>
                        <div class="text-10px font-500 color-#fff">
                            {{ t('messageDetail.levelFormat', { level: 2 }) }}
                        </div>
                        <div class="text-10px font-500 color-#fff">
                            {{ t('messageDetail.levelFormat', { level: 3 }) }}
                        </div>
                        <div class="text-10px font-500 color-#fff">
                            {{ t('messageDetail.levelFormat', { level: 4 }) }}
                        </div>
                        <div class="text-10px font-500 color-#fff">
                            {{ t('messageDetail.levelFormat', { level: 5 }) }}
                        </div>
                    </div>
                    <div v-if="showLevelTip" @click.stop
                        class="absolute top-40px w-100% color-#000 right-0 bg-#fff p-10px z-1000 rounded-10px">
                        <div class="text-12px">
                            {{ t('messageDetail.increaseFavorability') }}
                        </div>
                        <div class="text-12px">
                            {{ t('messageDetail.levelFormat', { level: 1 }) }} ({{ info?.expLevel1 }} {{ t('messageDetail.messageCount', { count: info?.expLevel1 }) }})
                        </div>
                        <div class="text-12px">
                            {{ t('messageDetail.levelFormat', { level: 2 }) }} ({{ info?.expLevel2 }} {{ t('messageDetail.messageCount', { count: info?.expLevel2 }) }})
                        </div>
                        <div class="text-12px">
                            {{ t('messageDetail.levelFormat', { level: 3 }) }} ({{ info?.expLevel3 }} {{ t('messageDetail.messageCount', { count: info?.expLevel3 }) }})
                        </div>
                        <div class="text-12px">
                            {{ t('messageDetail.levelFormat', { level: 4 }) }} ({{ info?.expLevel4 }} {{ t('messageDetail.messageCount', { count: info?.expLevel4 }) }})
                        </div>
                        <div class="text-12px">
                            {{ t('messageDetail.levelFormat', { level: 5 }) }} ({{ info?.expLevel5 }} {{ t('messageDetail.messageCount', { count: info?.expLevel5 }) }})
                        </div>
                    </div>
                </div>
                <div class="overflow-y-auto h-50vh">
                    <div class="color-#fff text-12px font-900">
                        {{ t('messageDetail.album') }}
                    </div>
                    <div class="flex flex-wrap gap-10px">
                        <div class="rounded-10px overflow-hidden w-105px h-158px mt-10px relative"
                            @click="handlePreviewAlbum(item.url, item.typeSee, item, index)"
                            v-for="(item, index) in backgroundStore.backgroundList" :key="item">
                            <AppImage :src="item.url" alt="avatar" width="100%" height="100%" :show-loading="true"
                                :show-error="true" :lazy-load="false" :custom-loading="true" :custom-error="true"
                                fallback="@/assets/images/home/sitemap.webp" fit="cover"
                                @error="() => console.log('Image error:', item.url)" />
                            <div class="w-full h-full  locked-overlay" v-if="!item.isUnlock">
                                <img src="@/assets/images/other/lock.svg" alt=""
                                    class="w-13px h-13px absolute top-50% left-50% transform -translate-x-1/2 -translate-y-1/2">
                            </div>
                        </div>
                    </div>
                    <div class="color-#fff text-12px font-900 mt-15px mb-0px">
                        {{ t('messageDetail.intro') }}
                    </div>
                    <div class="text-14px font-500 color-#fff text-info">
                        {{ info?.creatorNotes || t('messageDetail.noIntro') }}
                    </div>
                    <div class="color-#fff text-12px font-900 mt-15px" v-if="info?.tags || info?.roleInfo?.tags">
                        {{ t('messageDetail.tags') }}
                    </div>
                    <div class="flex flex-wrap" v-if="info?.tags || info?.roleInfo?.tags">
                        <div v-for="item in info?.tags || info?.roleInfo?.tags" :key="item" class="text-info-item">
                            {{ item }}
                        </div>
                    </div>
                    <AppOccupySpace height="100px"></AppOccupySpace>
                </div>
                <div class="btn" @click="router.back()">
                    {{ t('messageDetail.backToChat') }}
                </div>

            </div>
            <AppOccupySpace height="50px"></AppOccupySpace>
        </appPage>
        <van-popup v-model:show="showPopup" position="bottom" round class="p-20px">
            <Report :recordId="''" :reportType="reportType" :close="handleClosePopup" :info="info" />
        </van-popup>

        <!-- 全屏图片预览 -->
        <FullscreenImagePreview v-model:show="showImagePreview" :images="previewImages" :infoItem="infoItem"
            :start-position="previewStartPosition" @close="handleCloseImagePreview"
            :isShowSetAsBackdrop="isShowSetAsBackdrop" @check-bg="handleSetBackGround"
            @unlockSuccess="handleUnlockSuccess" :isShowbackDrop="isShowbackDrop"
            :numberChatMessages="numberChatMessages" :numberChatMessagesTotal="info?.levelExpOrigin" />
    </div>
</template>

<script setup lang="ts">
import { calculateLevelProgress } from './index.ts'
import AppImage from '@/components/display/AppImage.vue'
import { AppPage, AppOccupySpace } from '@/components/layout'
import { useRouter, useRoute } from 'vue-router'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useDialog } from '@/composables/useDialog'
import { theme } from '@/styles/theme'
import reportIcon from '@/assets/images/message/report.svg'
import { MessageAPI } from '@/services/message'
import Report from './Component/ChatReport.vue'
import { FullscreenImagePreview } from '@/components/feedback'
import { showFailToast, showLoadingToast, showSuccessToast } from 'vant'
import { useUserStore } from '@/stores/user'
import { computed } from 'vue'
import { useBackgroundStore } from '@/stores/background'
import { detailDB } from '@/utils/detailDB'
const router = useRouter()
const { t } = useI18n()
const dialog = useDialog()
// 路由
const route = useRoute()
// 角色详情
const info = ref<any>(null)
// 用户存储
const userStore = useUserStore()
// 聊天费用
const expenses = computed(() => userStore.getChatExpenses())
// 等级进度
const expList = ref()
// 进度百分比
const progressPercent = ref()
// 背景存储
const backgroundStore = useBackgroundStore()
// 弹出框
const showPopover = ref(false)
const showPopup = ref(false)
// 举报类型
const reportType = ref<any[]>([])
// 预览名字
const showPreviewName = ref(false)
// 等级提示
const showLevelTip = ref(false)
// 设置背景
const isShowSetAsBackdrop = ref(false)
// 是否显示背景遮罩
const isShowbackDrop = ref(false)
// 全屏预览状态
const showImagePreview = ref(false)
// 预览图片
const previewImages = ref<string[]>([])
// 预览起始位置
const previewStartPosition = ref(0)
// 预览信息
const infoItem = ref<any>(null)
// 聊天消息数量
const numberChatMessages = ref<number | undefined>(0)
// 点赞动画状态
const isLiking = ref(false)
const isShowFree = computed(() => userStore.getIsFree().includes(info.value?.pid))

const popoverList = ref([
    {
        name: 'Report',
        icon: reportIcon,
    },
])


/**
 * 返回
 */
const handleBack = () => {
    const preData = {
        name: info.value?.name,
        avatar: info.value?.avatar,
        background: info.value?.backgroundThumb || info.value?.roleInfo?.backgroundThumb,
        id: info.value?.id,
        creatorNotes: info.value?.creatorNotes,
    }
    router.push({
        path: '/chat',
        query: {
            preData: encodeURIComponent(JSON.stringify(preData)),
            route: route.query.route as string
        }
    })
}

/**
 * 预览名字
 */
const handlePreviewName = () => {
    showPreviewName.value = !showPreviewName.value
}

/**
 * 切换等级提示显示状态
 */
const handleToggleLevelTip = () => {
    showLevelTip.value = !showLevelTip.value
}
/**
 * 点赞
 */
const handleLike = async () => {
    // 触发心跳动画
    isLiking.value = true

    // 动画持续时间
    setTimeout(() => {
        isLiking.value = false
    }, 600)

    if (info.value?.roleInfo) {
        info.value.roleInfo.isFavorite = !info.value?.roleInfo.isFavorite
    } else {
        info.value.isFavorite = !info.value?.isFavorite
    }
    await detailDB.save(info.value?.id, info.value)
    try {
        await MessageAPI.favoriteRole({
            roleId: info.value?.id,
        })
    } catch (error) {
        showFailToast('Collection failed')
    }
}

/**
 * 弹出框
 */
const handlePopover = (name: string) => {
    if (name === 'Report') {
        showPopup.value = true
    } else if (name === 'Edit Profile') {
        router.push({ name: 'EditProfile' })
    } else if (name === 'Delete Message') {
    }
}

/**
 * 获取举报类型
 */
const getReportType = async () => {
    const res = await MessageAPI.reportType()
    reportType.value = res.data
}

/**
 * 关闭弹窗
 */
const handleClosePopup = () => {
    showPopup.value = false
}

/**
 * 预览头像
 */
const handlePreviewAvatar = () => {
    if (!info.value?.avatar) {
        return
    }

    previewImages.value = [info.value?.avatar]
    previewStartPosition.value = 0
    showImagePreview.value = true
    isShowbackDrop.value = false
    isShowSetAsBackdrop.value = false
}

/**
 * 预览专辑
 */
const handlePreviewAlbum = (url?: string, typeSee?: number, item?: any, index?: number) => {
    isShowSetAsBackdrop.value = !item.isUnlock
    infoItem.value = item
    numberChatMessages.value = index
    // 构建图片数组，可以包含多张图片
    const images = []

    // 添加背景图片
    if (url) {
        images.push(url)
    }

    // 如果没有图片，显示提示
    if (images.length === 0) {
        console.warn('没有可预览的图片')
        return
    }

    previewImages.value = images
    previewStartPosition.value = 0
    showImagePreview.value = true
    isShowbackDrop.value = true
}

/**
 * 预览背景专辑
 */
const handlePreviewBackgroundAlbum = (url?: string) => {
    if (!url) {
        console.warn('没有可预览的背景')
        return
    }
    previewImages.value = [url]
    previewStartPosition.value = 0
    showImagePreview.value = true
    isShowbackDrop.value = false
    isShowSetAsBackdrop.value = false
}

/**
 * 关闭图片预览
 */
const handleCloseImagePreview = () => {
    showImagePreview.value = false
    previewImages.value = []
    previewStartPosition.value = 0
}

/**
 * 获取角色相册
 */
const getRoleAlbum = async () => {
    await backgroundStore.getBackgroundList(info.value?.id)
}

/**
 * 设置背景
 */
const handleSetBackGround = async () => {
    showLoadingToast(t('message.setting'))
    await MessageAPI.setRoleImage({
        imageId: infoItem.value.id
    }).then(() => {
        detailDB.update(info.value?.id, info.value)

        if (info.value?.background) {
            info.value.background = infoItem.value.url
        } else if (info.value?.roleInfo) {
            info.value.roleInfo.background = infoItem.value.url
        } else {
            // 如果都没有，创建一个 roleInfo 对象
            info.value.roleInfo = { background: infoItem.value.url }
        }
        showSuccessToast('Successful switch')


        const preData = {
            name: info.value?.name,
            avatar: info.value?.avatar,
            background: info.value?.background || info.value?.roleInfo?.background,
            id: info.value?.id,
            creatorNotes: info.value?.creatorNotes,
        }

        router.push({
            path: '/chat',
            query: { preData: encodeURIComponent(JSON.stringify(preData)), route: route.query.route as string }
        })
        showImagePreview.value = false
    }).finally(() => {
        // closeToast()

    })
}

/**
 * 处理解锁成功
*/
const handleUnlockSuccess = async (imageId: number) => {
    // 更新本地相册数据，将解锁的图片标记为已解锁
    if (backgroundStore.backgroundList) {
        const unlockedItem = backgroundStore.backgroundList.find((item: any) => item.id === imageId)
        if (unlockedItem) {
            unlockedItem.isUnlock = true
        }
    }
    // 当前预览应立即去除遮罩
    isShowSetAsBackdrop.value = false
    await backgroundStore.getBackgroundList(info.value?.id)
}
/**
 * 获取数字人详情
*/
const getRoleDetail = async (id: string) => {
    info.value = await detailDB.get(id)

    const res = await MessageAPI.getRoleDetail({
        id: Number(id),
    })
    if (res.data) {
        info.value = res.data
        expList.value = [info.value?.expLevel1, info.value?.expLevel2, info.value?.expLevel3, info.value?.expLevel4, info.value?.expLevel5]
        progressPercent.value = calculateLevelProgress(expList.value, info.value?.levelExpOrigin)
    }
}

const imgLoading = ref(false)

const handleLoad = () => {
    imgLoading.value = true
}

onMounted(async () => {
    console.log(route);

    // 获取详情数据
    if (route.query.id) {
        info.value = await detailDB.get(route.query.id as string)
    }
    console.log(info.value);

    // 获取举报类型
    await getReportType()
    // 获取角色详情
    await getRoleDetail(route.query.id || info.value?.id)
    // 获取角色相册
    await getRoleAlbum()
})
</script>

<style scoped lang="scss">
.header-center {
    background-color: v-bind('theme.colors.backgroundTertiary');
    padding: 2px 5px;
    padding-bottom: 3px;
    border-radius: 25px;
    padding-left: 2px;
}

.header-center-id {
    color: v-bind('theme.colors.textPrimary');
    // margin-top: 1px;
}

.van-popup {
    background: linear-gradient(180deg, #D8DDFF 0%, #FFFFFF 100%);
}

.text-info {
    color: v-bind('theme.colors.textPrimary');
}

.text-info-item {
    background-color: v-bind('theme.colors.backgroundQuinary');
    padding: 2px 8px;
    font-weight: 500;
    font-size: 12px;
    color: #FFFFFF;
    margin-right: 10px;
    margin-top: 10px;
    border-radius: 10px;
}

/* 心跳动画 */
.heartbeat {
    animation: heartbeat 0.6s ease-in-out;
}

@keyframes heartbeat {
    0% {
        transform: scale(1);
    }

    14% {
        transform: scale(1.3);
    }

    28% {
        transform: scale(1);
    }

    42% {
        transform: scale(1.3);
    }

    70% {
        transform: scale(1);
    }
}

.van-popup {
    background: linear-gradient(180deg, #D8DDFF 0%, #FFFFFF 100%);
    border-radius: 10px;
}

.locked-overlay {
    position: absolute;
    top: 0px;
    left: 0px;
    background: rgba(1, 3, 27, 0.5);
    // border-radius: 10px;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
}

.btn {
    background: linear-gradient(180deg, #5A68FF 0%, #95A5FF 100%);
    border-radius: 23px;
    position: fixed;
    bottom: 4%;
    left: 4%;
    width: 92%;
    height: 46px;
    font-weight: 900;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
    line-height: 46px;
}

.progress-bar {
    width: 100%;
    height: 4px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
    // margin-top: 10px;
    position: relative;

    .progress-fill {
        height: 100%;
        // background: linear-gradient(90deg, #7B88FF 0%, #A78BFA 100%);
        // background: linear-gradient(270deg, #5A68FF 0%, #95A5FF 100%);
        background: linear-gradient(117deg, #9A4BE7 0%, #E44D84 100%);
        border-radius: 8px;
        transition: width 0.3s ease;
    }

    .progress-fill-item {
        .item {
            background: rgba(255, 255, 255, 0.3);
        }

    }

    // 进度条上的小圆点
    // &::before {
    //   content: '';
    //   position: absolute;
    //   left: 0;
    //   top: 50%;
    //   transform: translateY(-50%);
    //   width: 12px;
    //   height: 12px;
    //   background: #7B88FF;
    //   border-radius: 50%;
    //   border: 2px solid #FFFFFF;
    //   z-index: 2;
    // }
}

.cover-img {
    object-fit: cover;
    /* 或者 cover */
}
</style>